(function () {
  function init(root) {
    const mapEl = root.querySelector('[data-map]');
    const selectEl = root.querySelector('[data-select]');
    if (!mapEl || !selectEl || !window.mapboxgl) return;

    const token = mapEl.dataset.mapboxToken;
    if (!token || token === 'pk.test') {
      console.warn('Mapbox token missing in section settings.');
      return;
    }

    const style = mapEl.dataset.mapStyle || 'mapbox://styles/mapbox/streets-v12';
    const center = JSON.parse(mapEl.dataset.mapCenter || '[-74.044, 40.6892]');
    const zoom = Number(mapEl.dataset.mapZoom || 9);

    let locations = [];
    try {
      locations = JSON.parse(mapEl.dataset.locations || '[]');
    } catch (e) {
      console.warn('Invalid locations JSON in section settings.');
      locations = [];
    }

    mapboxgl.accessToken = token;

    const map = new mapboxgl.Map({
      container: mapEl,
      style,
      center,
      zoom
    });

    const markers = [];

    // Add dropdown options + markers
    locations.forEach((loc, idx) => {
      const opt = document.createElement('option');
      opt.value = String(idx);
      opt.textContent = loc.name || `Location ${idx + 1}`;
      selectEl.appendChild(opt);

      const marker = new mapboxgl.Marker()
        .setLngLat([Number(loc.lng), Number(loc.lat)])
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            loc.description || `<strong>${loc.name || 'Location'}</strong>`
          )
        )
        .addTo(map);

      markers.push(marker);
    });

    function fitAll() {
      if (!locations.length) return;
      const bounds = new mapboxgl.LngLatBounds();
      locations.forEach((loc) => bounds.extend([Number(loc.lng), Number(loc.lat)]));
      map.fitBounds(bounds, { padding: 50 });
    }

    map.on('load', fitAll);

    selectEl.addEventListener('change', (e) => {
      const v = e.target.value;
      if (v === 'show-all') {
        fitAll();
        return;
      }

      const i = Number(v);
      const loc = locations[i];
      if (!loc) return;

      map.flyTo({ center: [Number(loc.lng), Number(loc.lat)], zoom: 14 });

      const marker = markers[i];
      if (marker) marker.getPopup().addTo(map);
    });
  }

  function boot() {
    document.querySelectorAll('[data-store-locator]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
